// extracted by mini-css-extract-plugin
export default {"regularbtn":"Button_regularbtn__7gVPb","add_btn":"Button_add_btn__oPWNX","cancel_btn":"Button_cancel_btn__tSgV1","greenish":"Button_greenish__AG59p","redish":"Button_redish__6qQUN"};